import React, {useState} from 'react'
import { useTranslation } from "react-i18next";
import styles from './Contact.module.css'
import { useDispatch } from 'react-redux';
import { setContactUs } from '../../redux/Slices/users/thunk';
import notify from '../Utilities/notify';
import { Spinner } from "react-bootstrap";

 function Contact({oneUser}) {
      const { t, i18n } = useTranslation();
      const dispatch = useDispatch();
      const currentLanguage = i18n.language; 
    const [userName, setUserName] = useState(()=>oneUser?.cln_username.trim() || "");
    const [phoneNumber, setPhoneNumber] = useState(()=>oneUser?.cln_mobl?.trim() || "");
    const [note, setNote] = useState("");
    const [loading,setLoading]=useState(false)

    const onSubmit = async ()=>{
      let data = {
        clientId:oneUser?.cln_key,
        mobile:oneUser?.cln_mobl?.trim(),
        name:oneUser?.cln_username,
        description:note
      }
      console.log("data",data)
      if(note ==""){
        return notify(t("writeDescription"),"error")
      }
      try{
        setLoading(true)
        await dispatch(setContactUs(data))
        setNote("")
        
      }catch(e){
      }finally{
        setLoading(false)

      }
    }

  
  return (
    <div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column", gap:"20px"}} className={styles.container}>
<div className={styles.inputWrapperWithIcon}>
            <input
              type="text"
              placeholder={t("userName")}
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              className={styles.inputField}
              disabled
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              className={styles.inputIcon}
            >
              <path
                d="M20.2682 19.0577C20.1016 19.0411 19.9016 19.0411 19.7182 19.0577C15.7516 18.9244 12.6016 15.6744 12.6016 11.6744C12.6016 7.59108 15.9016 4.27441 20.0016 4.27441C24.0849 4.27441 27.4016 7.59108 27.4016 11.6744C27.3849 15.6744 24.2349 18.9244 20.2682 19.0577Z"
                stroke="#8B8C8C"
                hstrokewidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.9352 25.2084C7.90182 27.9084 7.90182 32.3084 11.9352 34.9917C16.5185 38.0584 24.0352 38.0584 28.6185 34.9917C32.6518 32.2917 32.6518 27.8917 28.6185 25.2084C24.0518 22.1584 16.5352 22.1584 11.9352 25.2084Z"
                stroke="#8B8C8C"
                hstrokewidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className={styles.inputContainer2}>
          {/* {currentLanguage === "en" &&  <div className={styles.inputWrapper}>
            
              <span>+966</span>
            </div>} */}
            <div className={styles.inputWrapperWithIcon}>
              <input
                type="number"
                placeholder={t("phoneNumber")}
                className={styles.inputField2}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                onWheel={(e) => e.preventDefault()} // Prevent wheel scroll
                style={{width:"100%"}}
                disabled
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
                className={styles.inputIcon}
              >
                <path
                  d="M25.8294 5.5H14.9961C12.2347 5.5 9.99609 7.73858 9.99609 10.5V31.3333C9.99609 34.0948 12.2347 36.3333 14.9961 36.3333H25.8294C28.5908 36.3333 30.8294 34.0948 30.8294 31.3333V10.5C30.8294 7.73858 28.5908 5.5 25.8294 5.5Z"
                  stroke="#8B8C8C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18.7461 30.5H22.0794"
                  stroke="#8B8C8C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            {/* {currentLanguage === "ar" &&  <div className={styles.inputWrapper}>
         
              <span>+966</span>
            </div>} */}
          </div>
          <div className={styles.inputContainer2}>
          <textarea
        style={{ width: "100%", height: "210px", padding:"15px" , border:"2px solid #D1D1D1", borderRadius:"8px", outline: "none", boxShadow: "none"}}
        value={note} // Bind the value to the state
        onChange={(e) => setNote(e.target.value)} // Handle the change event
        rows={6} // Sets the number of rows for the text area
        placeholder={t('text')}
      />
    </div>

    <div className={styles.onSubmit} onClick={onSubmit} >
          {loading ? <Spinner /> : t('send')}
          </div>

    </div>
  )
}

export default Contact;
